
import React, { PureComponent } from 'react';
import {LineChart, Line, XAxis, YAxis, CartesianGrid , } from 'recharts';
import styled from 'styled-components';



class CustomizedAxisTickX extends PureComponent {
  render () {
    const {x, y, stroke, payload} = this.props;
		
   	return (
    	<g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={15} textAnchor="middle" fill="#989898" transform="rotate(0)"  fontSize={"2.8vw"}>{payload.value} </text>
      </g>
    );
  }
};
class CustomizedAxisTickY extends PureComponent {
  render () {
    const {x, y, stroke, payload} = this.props;
		
   	return (
    	<g transform={`translate(${x},${y})`}>
        <text x={0} y={10} dy={0} textAnchor="middle" fill="#989898" transform="rotate(0)" fontSize={"2.8vw"}>{payload.value}</text>
      </g>
    );
  }
};



export default class Example extends PureComponent {

 getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return  width;
  }


  render() {
    return (
      <Inner className="graph" >
          <LineChart
            children
            width={this.getWindowDimensions()}
            // width={this.wd()}
            // height={200}
            height={this.getWindowDimensions()-180}
            data={this.props.chartMonthData ? this.props.chartMonthData : []}
          >
            <CartesianGrid
                strokeDasharray="0 0"
                stroke="#eaeaea"
                right="0"
                horizontal={0}
            />  
            <XAxis dataKey="name" 
                    tick={{fill:"#989898"}}
                    padding={{ left: 30, right: 30 }}
                    tickLine={0}
                    // tickSize={15}
                    axisLine={{stroke:"#ffc400",strokeWidth:0.5+"%"}}
                    tick={<CustomizedAxisTickX/>}
                  />
            <YAxis  tick={{fill:"#989898"}}
                    axisLine={{stroke:"#ffc400",strokeWidth:0.5+"%"}}
                    tickLine={0}
                    tickSize={15}
                    tick={<CustomizedAxisTickY/>}
                  >
            </YAxis>
            <Line 
                  dataKey="uv" 
                  stroke="#ffcf19"
                  strokeWidth="0.5%" 
                  fill="#ffcf19"  
                  dot={{ r:4 }}
                  textAnchor="middle"
              />
          </LineChart>
      </Inner>
    );
  }
}





const Inner = styled.div`
  position: relative;
  left:calc(100vw*(-35/375));
  width: 100vw;
`
